import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { RouletteNumberDisplay } from '../../../models/roulette.model';
import { RouletteHistoryService } from '../../../services/roulette-history.service';
import { RouletteService } from '../../../services/roulette.service';

@Component({
    selector: 'app-roulette-hot-cold',
    standalone: true,
    imports: [],
    templateUrl: './roulette-hot-cold.component.html',
    styleUrls: ['./roulette-hot-cold.component.scss']
})
export class RouletteHotColdComponent implements OnInit {
    displayedHotNumbers: RouletteNumberDisplay[] = [];
    displayedColdNumbers: RouletteNumberDisplay[] = [];
    private readonly maxDisplayCount = 6;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private readonly roulette: RouletteService,
        private readonly historyService: RouletteHistoryService
    ) {}

    ngOnInit(): void {
        this.historyService
            .getHistory$()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.updateDisplayedNumbers());
    }

    private updateDisplayedNumbers(): void {
        const hotNumbers = this.historyService.getHotNumbers(this.maxDisplayCount);
        const coldNumbers = this.historyService.getColdNumbers(this.maxDisplayCount);

        this.displayedHotNumbers = this.prepareNumbersForDisplay(hotNumbers);
        this.displayedColdNumbers = this.prepareNumbersForDisplay(coldNumbers);
    }

    private prepareNumbersForDisplay(numbers: number[]): RouletteNumberDisplay[] {
        return numbers.map((number) => ({
            value: number,
            displayValue: this.roulette.getDisplayValue(number),
            backgroundClass: this.roulette.getBackgroundColorClass(number)
        }));
    }
}
